module.exports = __webpack_public_path__ + "static/Pipe Dream.018b4451.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/work/Pipe Dream.png
// module id = 477
// module chunks = 35783957827783